module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index main"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "centered"
  }, [_vm._v("Форма сбора заявок")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('b-switch', {
    on: {
      "input": _vm.handleClaimInfoChange
    },
    model: {
      value: (_vm.mutateClaimInfo.enable),
      callback: function($$v) {
        _vm.$set(_vm.mutateClaimInfo, "enable", $$v)
      },
      expression: "mutateClaimInfo.enable"
    }
  }, [_vm._v("\n      Отображать на главной странице\n    ")])], 1), _vm._v(" "), _c('draggable', {
    staticClass: "drag-area",
    attrs: {
      "group": "order",
      "value": _vm.claims,
      "ghost-class": "ghost"
    },
    on: {
      "change": function($event) {
        return _vm.handleOrderChange($event)
      }
    }
  }, [_vm._l((_vm.claims), function(claim) {
    return _c('Claim', {
      key: claim.id,
      staticClass: "row",
      attrs: {
        "claim": claim
      }
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "button-wrapper centered",
    on: {
      "click": _vm.handleAddClaim
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("\n      Добавить\n    ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "row-wrapper row"
  }, [_c('div', {
    staticClass: "field-wrapper underwriting"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v("Брокеры")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleBrokersChange
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleSavePage
    }
  }, [_vm._v("\n      " + _vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ') + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.exportToCSV
    }
  }, [_vm._v("\n      Экспорт в csv\n    ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "centered shedule-controls"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mutateClaimInfo.timeForSync),
      expression: "mutateClaimInfo.timeForSync"
    }],
    staticClass: "input shedule-input",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.mutateClaimInfo.timeForSync)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mutateClaimInfo, "timeForSync", $event.target.value)
      }, _vm.handleClaimInfoChange]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleSendTimeForSync
    }
  }, [_vm._v("\n      " + _vm._s(_vm.disabled ? 'Идет сохранение...' : 'Сохранить') + "\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag-info"
  }, [_c('div', {
    staticClass: "drag-info-content"
  }, [_c('img', {
    staticClass: "drag-icon",
    attrs: {
      "src": "/static/img/icons/move.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        Чтобы поменять местами строки удерживайте и перетаскивайте их. "), _c('br'), _vm._v("\n        Порядок отображения строк влияет на порядок отображения пунктов в\n        форме\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered shedule-header"
  }, [_c('h3', {
    staticClass: "shedule-title"
  }, [_vm._v("Интервал синхронизации")]), _vm._v(" "), _c('p', [_vm._v("Значение задается в минутах.")]), _vm._v(" "), _c('p', [_vm._v("При значении "), _c('code', [_vm._v("0")]), _vm._v(" синхронизации не происходит.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e54bae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Underwriting/Index.vue
// module id = 910
// module chunks = 0